import { useSelector } from 'react-redux'
import { useUserRegion } from '@frontend/components/agromarket/components/RegionSelector'
import { getUserGtmInfo, pushGtmEvent } from '@/logic/metrika/helpers'
import type { RootState } from '@/redux/interfaces'

const mapState = (state: RootState) => ({
  user: getUserGtmInfo()(state),
})

export const useNewsGtmEvents = () => {
  const { user } = useSelector(mapState)
  const { userRegion } = useUserRegion()

  const onClickNewsItemGtmEvent = (publicationSlug: string) => {
    pushGtmEvent({
      event: 'userEvent',
      userAuth: user.userAuth,
      userImpersonalization: user.userImpersonalization,
      memberID: user.memberID,
      uid: user.uid,
      regionSelected: userRegion,
      eventCategory: 'interactions',
      eventAction: 'click',
      eventStatus: 'success',
      eventNonInteraction: '0',
      blockName: 'blockPublicationsMainInputs',
      eventLabel: publicationSlug,
    })
  }

  return { onClickNewsItemGtmEvent }
}
